module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.disv == 'w' && _vm.value > 10000) ? _c('span', {
    staticClass: "kwd"
  }, [(_vm.start) ? _c('small', [_vm._v(_vm._s(_vm.start))]) : _vm._e(), _vm._v(" " + _vm._s(_vm._f("formatW")(_vm.value))), _c('small', [_vm._v(_vm._s(_vm.$t('tenThousand')))])]) : (_vm.disv == 'k' && _vm.value > 1000) ? _c('span', {
    staticClass: "kwd"
  }, [(_vm.start) ? _c('small', [_vm._v(_vm._s(_vm.start))]) : _vm._e(), _vm._v(_vm._s(_vm._f("formatK")(_vm.value)) + " "), _c('small', [_vm._v("K")])]) : _c('span', {
    staticClass: "kwd"
  }, [(_vm.start) ? _c('small', [_vm._v(_vm._s(_vm.start))]) : _vm._e(), _vm._v(" " + _vm._s(_vm.value) + "\r\n  ")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-2834fbae","hasScoped":true}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/operaCommon/formatKW.vue
// module id = 1755
// module chunks = 107